import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { OmitPaginatedEndpointParams } from '../../types';
import { FindAvailableVouchersParams } from './businessPolicies.types';

export const BUSINESS_POLICIES_KEY = 'business-policies';

export const getBusinessPoliciesKey = (): UseDataQuery['queryKey'] => [BUSINESS_POLICIES_KEY];

export const getBusinessPolicyKey = (id: string): UseDataQuery['queryKey'] => [
  BUSINESS_POLICIES_KEY,
  id,
];

export const getFindAvailableVouchersKey = (
  params: OmitPaginatedEndpointParams<FindAvailableVouchersParams>,
): UseDataQuery['queryKey'] => ['business-policy-vouchers/available', undefined, params];
